.slot {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--tuna-spacing-1);
  min-width: 4.5rem;
  min-height: 5rem;
  padding: var(--tuna-spacing-2);
  border: 1px solid var(--tuna-border-default);
  border-radius: var(--tuna-shape-borderRadius);
  background: var(--tuna-surface-elevated);
  cursor: pointer;
}

.selected {
  border-color: var(--tuna-palette-primary-main);
  background: var(--tuna-surface-elevated);
}

.active {
  outline: 2px solid var(--tuna-palette-primary-main);
  outline-offset: -2px;
}

.chordName {
  font-size: var(--tuna-typography-body1-fontSize);
  font-weight: 600;
}

.roman {
  font-size: var(--tuna-typography-body2-fontSize);
  color: var(--tuna-content-secondary);
}

.index {
  font-size: var(--tuna-typography-caption-fontSize);
  color: var(--tuna-content-muted);
}
